/** Returns the given number with a fixed presicion without rounding it. */
export default (num: number | null | undefined, fixed = 0): string => {
  if (num === null || num === undefined) {
    return '';
  }
  const regEx = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');
  return regEx.exec(num.toString())![0] ?? '';
};
